import { render } from "./AccountSetting.vue?vue&type=template&id=14a7901c"
import script from "./AccountSetting.vue?vue&type=script&lang=js"
export * from "./AccountSetting.vue?vue&type=script&lang=js"
script.render = render

export default script